module.exports = __webpack_public_path__ + "static/media/retailimg.e206f348.png";